import React from 'react'
import Layout from './src/layouts/index.js'

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

export const onRouteUpdate = ({ location }) => {
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1') return

  const path = location.pathname
  if (path === '/visits' || path.startsWith('/visits/')) return

  fetch('/api/visits', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ path }),
    keepalive: true,
  }).catch(() => {})
}